// extracted by mini-css-extract-plugin
module.exports = {"iframeWrapper":"Re-z"};